import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, LinearProgress } from "@mui/material";
import WarningTwoToneIcon from '@mui/icons-material/WarningTwoTone';

const InvoiceButtonDialog = ({ data, open, onClose, onSuccess }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleSelfClose = () => {
        onClose();
    }

    const handleDelete = () => {
        setIsLoading(false);
        onSuccess();
        onClose();
    }

    if (data === null || open === false) return "";
    return (
        <Dialog open={open} onClose={handleSelfClose}>
            <DialogTitle className="align_text" color="warning"><WarningTwoToneIcon /> &nbsp; Warning!</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Canceling this invoice is <strong>permanent</strong> and <strong>cannot be undone</strong>.
                    Once canceled, you will not be able to restore it. A new invoice must be created if needed.
                </DialogContentText>
                <DialogContentText>
                    इस चालान को रद्द करना <strong>स्थायी</strong> है और इसे <strong>वापस नहीं लाया जा सकता</strong>। एक बार रद्द करने के बाद, आप इसे पुनर्स्थापित नहीं कर पाएंगे। यदि आवश्यक हो तो एक नया चालान बनाना होगा।
                </DialogContentText>
            </DialogContent>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <DialogActions>
                <Button onClick={handleSelfClose} color="primary">
                    No, Go Back
                </Button>
                <Button onClick={handleDelete} color="error" variant="contained" disabled>
                    Yes, Cancel Invoice
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InvoiceButtonDialog;
